import { styled, Chip } from "@mui/material";
import { SHOPKEEPER_STATUS, type ShopkeeperStatus } from "../../constants";



const statusColors = {
  [SHOPKEEPER_STATUS.PENDING]: {
    bg: "#E3F2FD",
    color: "#1565C0",
  },
  [SHOPKEEPER_STATUS.ISSUED]: {
    bg: "#E8F5E9",
    color: "#2E7D32",
  },
  [SHOPKEEPER_STATUS.REJECTED]: {
    bg: "#FFEBEE",
    color: "#C62828",
  },
};

export const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "status",
})<{ status: ShopkeeperStatus }>(({ status }) => {
  const theme = statusColors[status];

  return {
    fontSize: "0.75rem",
    fontWeight: 500,
    borderRadius: "8px",
    textTransform: "capitalize",
    backgroundColor: theme.bg,
    color: theme.color,

    "& .MuiChip-icon": {
      color: theme.color,
      fontSize: "0.6rem",
      marginLeft: 6,
    },
  };
});
